package uz.ferro.shop.ui.productgroup

import react.FC
import react.Props
import uz.ferro.shop.model.ProductGroup
import uz.ferro.shop.model.ProductGroupUIType

external interface ProductGroupViewProps : Props {
    var viewType: ProductGroupUIType?
    var productGroup: ProductGroup
}

val ProductGroupView = FC<ProductGroupViewProps> { props ->
    if (props.viewType == ProductGroupUIType.VERTICAL_GRID) {
        ProductGroupProductsVerticalView {
            productGroup = props.productGroup
        }
    } else {
        ProductGroupProductsHorizontalView {
            productGroup = props.productGroup
        }
    }
}